export default "/images/47d58fcf5ca4482ec6cc9697c7194659.avif";